/**
 * Outfit renders the table component corresponding to an outfit
 * TODO: separate outfit into audit page outfit and browse audted outfit components (instead of using enableReEdit flag property)
 */
import React from 'react';
import {
    ColumnLayout,
    Button,
    Alert, 
    Cards
} from 'AWS-UI-Components-React';
import {AuditButton} from './auditButton.jsx';
import {Item} from './item.jsx';
import '../styles/outfit.css';
import momentTz from 'moment-timezone';
import {AMZN_DOMAIN} from './constants.jsx'

const numCols = 6
const green = '#39D1B4';
const red = '#ff0000';

const enableCollection = true;

const validAuditStatus = new Set(["Auto Accepted", "Accepted", "Partially Accepted", "Rejected"])

export class Outfit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            statusMsg: "",
            lastAuditUser: this.props.outfitInfo.audit_user,
            lastAuditTime: this.props.outfitInfo.audit_date,
            lastAuditStatus: this.props.outfitInfo.audit_status
        };
        this.asins = {};
        this.outfitItems = this.props.outfitInfo.items;
        this.originalOutfitItems = JSON.parse(JSON.stringify(this.props.outfitInfo.items));
        this.generateItems = this.generateItems.bind(this);
        this.storeAuditOutfit = this.storeAuditOutfit.bind(this);
        this.generateCardsPerRow = this.generateCardsPerRow.bind(this);
        this.saveReAudit = this.saveReAudit.bind(this);
        this.saveReAuditErrorCallback = this.saveReAuditErrorCallback.bind(this);
        this.changedItemCount = 0;
        this.originalRejectionReasons = [];
        this.numRequired = 0;
    }

    componentWillMount() {
        for (let i = 0; i < this.outfitItems.length; i++) {
            this.asins[i] = React.createRef();
            this.originalRejectionReasons.push(new Set(this.originalOutfitItems[i].rejection_reason_list));
        }
    }

    /** Passes audit status back and keep track of items changed if re-auditing */
    storeAuditOutfit = (status, flag, rejectionReasons, itemNum) => {
        if (this.props.enableReEdit) {
            var diffRejectionReasons = this.compareRejectionReasons(rejectionReasons, itemNum)
            if (this.originalOutfitItems[itemNum].audit_status != status || diffRejectionReasons) {
                if (this.outfitItems[itemNum].edited != true) {
                    this.outfitItems[itemNum].edited = true;
                    this.changedItemCount += 1;
                }
            } else {
                this.outfitItems[itemNum].edited = false;
                this.changedItemCount -=1;
            }
            this.asins[itemNum].current.changeEdited(this.outfitItems[itemNum].edited);

            const itemFlag = this.outfitItems[itemNum].flag;
            if (itemFlag === undefined) {
                this.outfitItems[itemNum].flag = flag;
                if(flag) {
                    this.numRequired += 1;
                }
            } else if (itemFlag != flag) {
            this.outfitItems[itemNum].flag = flag
                if (flag) {
                    this.numRequired += 1;
                } else {
                    this.numRequired -= 1;
                }
            }
        }
        this.outfitItems[itemNum].status = status;
        this.outfitItems[itemNum].rejection_reason_list = rejectionReasons;
        this.props.storeAudit(this.props.batchNum, status, flag, rejectionReasons, itemNum);
    }

    /**Returns true if the rejection reasons are different from the original*/
    compareRejectionReasons = (rejectionReasons, itemNum) => {
        if (this.originalRejectionReasons[itemNum].size != rejectionReasons.length) {
            return true;
        }

        for (var i = 0; i < rejectionReasons.length; i++) {
            if (!this.originalRejectionReasons[itemNum].has(rejectionReasons[i])) {
                return true;
            }
        }
        return false;
    }
    
    /**Creates the content for each column - Max 5 items + 1 cell for Accept/Reject buttons on each row*/
   generateItems() {
       const rows = []
       let i = 0;
       for (; i < Math.max(numCols - 1, this.outfitItems.length); i++) {
           if (this.outfitItems[i]) {
                rows[i] = {
                    header: <a target="_blank" href={`https://${AMZN_DOMAIN[this.props.outfitInfo.marketplace_id]}/dp/${this.outfitItems[i].child_asin}`}>
                    {this.outfitItems[i].category}</a>,
                    item: <Item 
                    ref={this.asins[i]} 
                    item={this.outfitItems[i]}
                    enableCollection={enableCollection}
                    originalItem={this.outfitItems[i]}
                    storeAuditOutfit={this.storeAuditOutfit} 
                    seedCategory={this.props.outfitInfo.seed_category} 
                    itemNum={i} 
                    enableReEdit={this.props.enableReEdit} />
                }
            }
       }
       
        if (this.props.enableReEdit) {
            rows[i] = {
                header: "Actions",
                item: (
                    <div>
                        <div>
                            <AuditButton
                            disabled={!validAuditStatus.has(this.state.lastAuditStatus)}
                            text="Save"
                            handler={this.saveReAudit.bind(this)}
                            />
                        </div>
                        <div>
                            {this.state.statusMsg}
                        </div>
                    </div>
                )
            }
        } 
       return rows
   }

    generateCardsPerRow() {
        const cardWidth = 250; // in pixels
        const cardsPerRow = [];

        for (let i = 0; i < numCols; i++) {
            cardsPerRow[i] = {
                cards: i + 1,
                minWidth: cardWidth * i
            }
        }

        return cardsPerRow
   }

   showOutfitHeader() {
       return (
        <ColumnLayout columns={2}>
            <div data-awsui-column-layout-root="true">
                <div>
                    Outfit ID: {this.props.outfitInfo.outfit_id}
                </div>
                <div>
                    { this.props.enableReEdit ? 
                        <div>
                            <div>
                            Audit User: {this.state.lastAuditUser}
                            </div>
                            <div>
                            {/* Modify date to local timezone */}
                            Audit Date: {momentTz.tz(this.state.lastAuditTime, momentTz.tz.guess()).format("YYYY-MM-DD, HH:mm:ss z")}
                            </div>
                            <div>
                            Audit Status: {this.state.lastAuditStatus}
                            </div>
                        </div> : null
                    }
                </div>
            </div>
        </ColumnLayout>
       );
   }

   /** Save the re-audited outfit to datastore, if it hasn't been changed, display a message */
    async saveReAudit() {
        if (this.changedItemCount == 0) {
            return setTimeout(() => { 
                this.setState((state, props) => {
                    return ({ 
                        statusMsg: <Alert
                        content={`Outfit has not been changed. (${new Date().toLocaleString()})`}
                        type="info"
                        dismissible={true}
                        ></Alert>
                    });
                });
            });
        }

        if (enableCollection && this.numRequired > 0) {
            return setTimeout(() => { 
                this.setState((state, props) => {
                    return ({ 
                        statusMsg: <Alert
                        content={`${this.numRequired} item(s) still require rejection reasons. (${new Date().toLocaleString()})`}
                        type="info"
                        dismissible={true}
                        ></Alert>
                    });
                });
                for (let i = 0; i < Math.max(numCols - 2, this.outfitItems.length - 1); i++) {
                    this.asins[i].current.changeEdited(this.outfitItems[i].edited);
                }
            });
        }

        const saveResult = await this.props.saveReAudit(this.props.batchNum, this.saveReAuditErrorCallback);
        if (saveResult) {
            this.changedItemCount = 0;
            this.originalRejectionReasons = [];
            this.originalOutfitItems = JSON.parse(JSON.stringify(this.outfitItems));
            for (let i = 0; i < Math.max(numCols - 2, this.outfitItems.length - 1); i++) {
                this.originalOutfitItems[i].audit_status = this.outfitItems[i].audit_status.slice();
                this.originalOutfitItems[i].rejection_reason_list = this.outfitItems[i].rejection_reason_list.slice();
                this.outfitItems[i].edited = false;
                this.asins[i].current.changeEdited(this.outfitItems[i].edited);
                this.originalRejectionReasons.push(new Set(this.originalOutfitItems[i].rejection_reason_list));
            }
            this.setState((state, props) => {
                return ({ 
                    statusMsg: <Alert
                    content={`Outfit has been successfully saved. New audit status is: `
                     + saveResult.data.outfits[0].audit_status + `. (${new Date().toLocaleString()})`}
                    type="success"
                    ></Alert>,
                    lastAuditUser: props.user,
                    lastAuditTime: saveResult.data.outfits[0].audit_date
                });
            });
        }
        return saveResult;        
    }

    saveReAuditErrorCallback(error) {
        this.setState((state, props) => {
            return ({
                statusMsg: <Alert
                header="Error saving outfit"
                content={`${error.response.data.message} (${new Date().toLocaleString()})`}
                type="error"
                ></Alert>
            });
        });
    }

    render () {
        const cardDef = {
            header: item => <h2>{item.header}</h2>,
            sections: [
                {
                    id: "sec1",
                    content: item => item.item
                }
            ]
        };

        const OutfitCard = () => (
            <div className="awsui-util-container awsui-util-no-gutters">
                <Cards
                    cardDefinition={cardDef}
                    items={this.generateItems()}
                    cardsPerRow={this.generateCardsPerRow()}
                    loadingText="Loading outfit"
                    header={
                        this.showOutfitHeader()
                    }
                ></Cards>
            </div>
        );

        return (
            <OutfitCard/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/outfit.jsx